<template>
  <div>
    <router-view></router-view>
    <!-- <back-link v-if="this.$route.meta.routerBack !== false"></back-link> -->
  </div>
</template>
<script>
// import backLink from '@/components/BackLink/index.vue'

export default {
  // components: {
  //   backLink
  // },
  // data () {
  //   return {
  //   }
  // },
}
</script>